export default defineAppConfig({
  ui: {
    colors: {
      primary: "pink",
      neutral: "zinc"
    }
  }
});
